/**
 * @generated SignedSource<<31d236ea22eff1548b8864478d7400bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivateFeaturesPLUClearPLUMutation$variables = Record<PropertyKey, never>;
export type ActivateFeaturesPLUClearPLUMutation$data = {
  readonly clearPLU: ReadonlyArray<{
    readonly id: string;
  }>;
};
export type ActivateFeaturesPLUClearPLUMutation = {
  response: ActivateFeaturesPLUClearPLUMutation$data;
  variables: ActivateFeaturesPLUClearPLUMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PLUCategory",
    "kind": "LinkedField",
    "name": "clearPLU",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivateFeaturesPLUClearPLUMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ActivateFeaturesPLUClearPLUMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "de5e0e578d58ffa07621400633243151",
    "id": null,
    "metadata": {},
    "name": "ActivateFeaturesPLUClearPLUMutation",
    "operationKind": "mutation",
    "text": "mutation ActivateFeaturesPLUClearPLUMutation {\n  clearPLU {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5cb48784f7eded82d30e5ed9f7235cc";

export default node;
